import React from 'react';

import { useQuickstartContext } from '../context';
import { getHeader, getUserData } from '../config/userSession';

export const useGetUser = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { user, setUser } = useQuickstartContext();
  const userData = getUserData();
  async function getUser() {
    try {
      setIsLoading(true);

      // Call your backend with the token
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/account/get-me`,
        {
          method: 'POST',
          headers: getHeader(),
          body: JSON.stringify({ email: userData.email })
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch user: ${response.status}`);
      }

      const respuser = await response.json();

      setUser(respuser);
    } catch (e) {
      console.error('Error fetching user:', e);
    } finally {
      setIsLoading(false);
    }
  }
  React.useEffect(() => {
    getUser();
  }, []);

  return { user, isLoading, getUser };
};
